<template>
  <div class="space-y-4">
    <!-- Review Encounter Tasks (Claim/Resubmission workflow) -->
    <div v-if="isEncounterTask" key="encounter">
      <Task_Review_Encounter :task="task"
                            @can_submit="update_can_submit"
      />
    </div>

    <!-- Review Suspect Tasks (Suspect/Early Start workflow) -->
    <div v-else-if="isSuspectTask" key="suspect">
      <Task_Review_Suspect :task="task"
                          @can_submit="update_can_submit"
      />
    </div>

    <!-- Medication Adherence Task -->
    <div v-else-if="isMedicationTask" key="medication">
      <Task_MedicationAdherence :task-id="task.id"
                                :opportunities="task.opportunities"
                                :task-type="task.task_type"
                                :task-type-name="task.task_type_name"
                                :task-metadata="task.metadata"
                                @can_submit="update_can_submit"
      />
    </div>
    <div v-else-if="isCareGapTask" key="caregap">
      <Task_Care_Gap_Closure :task-id="task.id"
                                :opportunities="task.opportunities"
                                :task-type="task.task_type"
                                :task-type-name="task.task_type_name"
                                :task-metadata="task.metadata"
                                @can_submit="update_can_submit"
      />
    </div>
  </div>
</template>

<script>
import Task_Review_Encounter from '@/components/Portal/Task_Tables/Task_Widgets/Task_Review_Encounter.vue';
import Task_Review_Suspect from '@/components/Portal/Task_Tables/Task_Widgets/Task_Review_Suspect.vue';
import Task_MedicationAdherence from "@/components/Portal/Task_Tables/Task_Widgets/Task_MedicationAdherence.vue";
import Task_Care_Gap_Closure from "@/components/Portal/Task_Tables/Task_Widgets/Task_Care_Gap_Closure.vue";

export default {
  name: 'Task_Widget_Parent',
  components: {
    Task_Care_Gap_Closure,
    Task_MedicationAdherence,
    Task_Review_Suspect,
    Task_Review_Encounter
  },
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  emits: ['can_submit'],
  computed: {
    taskName() {
      return (this.task.task_type_name || '').toLowerCase()
    },
    isEncounterTask() {
      return this.taskName.includes('claim') || this.taskName.includes('episource')
    },
    isSuspectTask() {
      return this.taskName.includes('suspect') || this.taskName.includes('early start') ||
             (this.taskName.includes('confirm') && !this.isEncounterTask) ||
             this.taskName.includes('1lr') || this.taskName.includes('2lr') ||
             this.taskName.includes('3lr')
    },
    isMedicationTask() {
      return this.taskName.includes('medication')
    },
    isCareGapTask() {
      return this.taskName.includes('care gap')
    },
  },
  methods: {
    update_can_submit(value, message) {
      this.$emit('can_submit', value, message)
    }
  }
}
</script>

<style scoped>
/* Component is now much simpler - just a container for task-specific widgets */
</style>
